var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.667 7a6.333 6.333 0 1 1 11.258 3.983l2.45 2.448a.667.667 0 0 1-.944.943l-2.448-2.449A6.333 6.333 0 0 1 .666 7M7 2a5 5 0 1 0 0 10A5 5 0 0 0 7 2",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;